<!-- Delete Modal -->
<div class="modal fade" id="delete_modal" aria-hidden="true" role="dialog">
  <div class="modal-dialog modal-dialog-centered" role="document">
    <div class="modal-content">
      <div class="modal-body">
        <div class="form-content p-2">
          <h4 class="modal-title">Delete</h4>
          <p class="mb-4">Are you sure want to delete?</p>
          <button type="button" class="btn btn-primary me-1">Yes</button>
          <button type="button" class="btn btn-danger" data-bs-dismiss="modal">
            Cancel
          </button>
        </div>
      </div>
    </div>
  </div>
</div>
<!-- /Delete Modal -->

<!-- Add Medical Detail -->
<div
  id="modal_medical_form"
  class="modal fade custom-modal"
  tabindex="-1"
  role="dialog"
  style="display: none"
  aria-hidden="true"
>
  <div class="modal-dialog modal-dialog-centered">
    <div class="modal-content">
      <form
        action="#"
        enctype="multipart/form-data"
        autocomplete="off"
        method="post"
      >
        <div class="modal-header">
          <h5 class="modal-title">Add new data</h5>
          <button
            type="button"
            class="btn-close"
            data-bs-dismiss="modal"
            aria-label="Close"
          ></button>
        </div>
        <div class="modal-body">
          <input type="hidden" value="" name="id" />
          <input type="hidden" value="insert" name="method" />
          <div class="mb-3">
            <label for="bmi" class="control-label mb-10">
              BMI <span class="text-danger">*</span></label
            >
            <input type="text" name="bmi" class="form-control" />
          </div>
          <div class="mb-3">
            <label for="heart-rate" class="control-label mb-10"
              >Heart rate
            </label>
            <input type="text" name="hr" class="form-control" />
          </div>
          <div class="mb-3">
            <label for="weight" class="control-label mb-10">Weight</label>
            <input type="text" name="Weight" class="form-control" />
          </div>
          <div class="mb-3">
            <label for="fbc" class="control-label mb-10">Fbc</label>
            <input type="text" id="Fbc" name="Fbc" class="form-control" />
          </div>
          <div class="mb-3">
            <label for="created-date" class="control-label mb-10"
              >Created Date
            </label>
            <input
              type="text"
              name="dob"
              id="dob"
              value=""
              readonly=""
              class="form-control"
            />
          </div>
        </div>
        <div class="modal-footer text-center">
          <button type="submit" class="btn btn-outline btn-success">
            Submit
          </button>
          <button
            type="button"
            id="medical"
            class="d-none"
            data-bs-dismiss="modal"
          ></button>
        </div>
      </form>
    </div>
  </div>
</div>
<!-- /Add Medical Detail -->

<!-- Edit Medical Detail -->
<div
  id="edit_medical_form"
  class="modal fade custom-modal"
  tabindex="-1"
  role="dialog"
  style="display: none"
  aria-hidden="true"
>
  <div class="modal-dialog modal-dialog-centered">
    <div class="modal-content">
      <form
        action="#"
        enctype="multipart/form-data"
        autocomplete="off"
        method="post"
      >
        <div class="modal-header">
          <h5 class="modal-title">Add new data</h5>
          <button
            type="button"
            class="btn-close"
            data-bs-dismiss="modal"
            aria-label="Close"
          ></button>
        </div>
        <div class="modal-body">
          <input type="hidden" value="" name="id" />
          <input type="hidden" value="insert" name="method" />
          <div class="mb-3">
            <label for="bmi" class="control-label mb-10">
              BMI <span class="text-danger">*</span></label
            >
            <input type="text" name="bmi" class="form-control" value="23.7" />
          </div>
          <div class="mb-3">
            <label for="heart-rate" class="control-label mb-10"
              >Heart rate
            </label>
            <input type="text" name="hr" class="form-control" value="89" />
          </div>
          <div class="mb-3">
            <label for="weight" class="control-label mb-10">Weight</label>
            <input type="text" name="Weight" class="form-control" value="74" />
          </div>
          <div class="mb-3">
            <label for="fbc" class="control-label mb-10">Fbc</label>
            <input type="text" name="Fbc" class="form-control" value="140" />
          </div>
          <div class="mb-3">
            <label for="created-date" class="control-label mb-10"
              >Created Date
            </label>
            <input
              type="text"
              name="dob"
              id="editdob"
              value="11/11/2023"
              readonly=""
              class="form-control"
            />
          </div>
        </div>
        <div class="modal-footer text-center">
          <button type="submit" class="btn btn-outline btn-success">
            Submit
          </button>
          <button
            type="button"
            id="modalAutoClose"
            class="d-none"
            data-bs-dismiss="modal"
          ></button>
        </div>
      </form>
    </div>
  </div>
</div>
<!-- /Edit Medical Detail -->

<!-- Medical Records Modal -->
<div
  class="modal fade custom-modal custom-medicalrecord-modal"
  id="add_medical_records_modal"
  tabindex="-1"
  role="dialog"
  aria-modal="true"
>
  <div class="modal-dialog modal-dialog-centered modal-lg" role="document">
    <div class="modal-content">
      <div class="modal-header">
        <div>
          <h5 class="modal-title">Add Medical Report</h5>
          <p>Upload and organise your health documents</p>
        </div>

        <button
          type="button"
          class="btn-close"
          id="closeMedicalModalBtn"
          data-bs-dismiss="modal"
          aria-label="Close"
          (click)="closePopup('medical')"
        ></button>
      </div>
      <form
        [formGroup]="medicalForm"
        (ngSubmit)="onSubmitMedicalRecords()"
        enctype="multipart/form-data"
      >
        <div class="modal-body">
          <div class="row">
            <div class="col-12 col-md-6">
              <div class="mb-3">
                <label class="mb-2" for="patient-select"
                  >Patient<span class="text-danger">*</span></label
                >
                <select
                  id="patient-select"
                  class="form-select form-control"
                  formControlName="patient"
                >
                  <option value="" disabled selected>Select Patient</option>
                  <option
                    *ngFor="let patient of patientList"
                    [value]="patient.user_id"
                  >
                    {{
                      patient.first_name +
                        " " +
                        patient.last_name +
                        (patient.is_logged_in_user ? " (Me)" : "")
                    }}
                  </option>
                </select>
                <div
                  class="text-danger mt-1"
                  *ngIf="
                    medicalForm.get('patient')?.touched &&
                    medicalForm.get('patient')?.invalid
                  "
                >
                  Patient is required.
                </div>
              </div>
            </div>

            <div class="col-12 col-md-6">
              <div class="mb-3">
                <label class="mb-2"
                  >Report Type<span class="text-danger">*</span></label
                >
                <select
                  id="report-type-select"
                  class="form-select form-control"
                  formControlName="report_type_id"
                  (change)="onRecordChange($event)"
                >
                  <option value="" disabled>Select Record</option>
                  <option
                    *ngFor="let reportList of medicalReportList"
                    [ngValue]="reportList"
                  >
                    {{ reportList.report_type }}
                  </option>
                </select>

                <div
                  class="text-danger mt-1"
                  *ngIf="
                    medicalForm.get('report_type_id')?.touched &&
                    medicalForm.get('report_type_id')?.invalid
                  "
                >
                  Report Type is required.
                </div>
              </div>
            </div>
          </div>

          <div class="row" *ngIf="selectedRecord === 'Others'">
            <div class="col-12">
              <div class="mb-3">
                <label class="mb-2"
                  >Other Report Type<span class="text-danger">*</span></label
                >
                <input
                  type="text"
                  class="form-control"
                  formControlName="report_type_description"
                  placeholder="Enter Record"
                />
                <div
                  class="text-danger mt-1"
                  *ngIf="
                    medicalForm.get('report_type_description')?.touched &&
                    medicalForm.get('report_type_description')?.invalid
                  "
                >
                  Please enter other report type.
                </div>
              </div>
            </div>
          </div>

          <div class="row">
            <div class="col-12">
              <div class="mb-3">
                <label class="mb-2"
                  >Hospital Name<span class="text-danger">*</span></label
                >
                <input
                  maxLength="200"
                  (keydown)="cleanInput($event)"
                  (input)="onlyAlphabet($event)"
                  type="text"
                  class="form-control"
                  placeholder="Enter Name"
                  formControlName="hospital"
                />
                <div
                  class="text-danger mt-1"
                  *ngIf="
                    medicalForm.get('hospital')?.touched &&
                    medicalForm.get('hospital')?.invalid
                  "
                >
                  Hospital Name is required.
                </div>
              </div>
            </div>
          </div>

          <div class="row">
            <div class="col-12">
              <div class="mb-3">
                <label class="mb-2"
                  >Report Name<span class="text-danger">*</span></label
                >
                <input
                  maxLength="200"
                  (keydown)="cleanInput($event)"
                  (input)="onlyAlphabet($event)"
                  type="text"
                  class="form-control"
                  placeholder="Enter Name"
                  formControlName="report_name"
                />
                <div
                  class="text-danger mt-1"
                  *ngIf="
                    medicalForm.get('report_name')?.touched &&
                    medicalForm.get('report_name')?.invalid
                  "
                >
                  Report Name is required.
                </div>
              </div>
            </div>
          </div>

          <div class="row">
            <div class="col-12">
              <div class="mb-3">
                <label class="mb-2"
                  >Report Issued On <span class="text-danger">*</span></label
                >
                <div class="position-relative">
                  <input
                    #dpMedical="bsDatepicker"
                    type="text"
                    class="form-control"
                    bsDatepicker
                    placement="top"
                    placeholder="Select Date"
                    (bsValueChange)="handleReportDate($event)"
                    [bsConfig]="medicalbsDatepickerConfig"
                    [outsideClick]="true"
                    inputmode="none"
                    readonly
                    onkeydown="return false;"
                  />
                  <i
                    class="fa-regular fa-calendar position-absolute"
                    (click)="dpMedical.toggle()"
                  ></i>
                </div>
                <p>⭕ Select the date when the test was conducted.</p>
                <div class="text-danger mt-1">
                  <div
                    style="color: red !important"
                    *ngIf="
                      medicalForm.get('treatmentDate')?.touched &&
                      medicalForm.get('treatmentDate')?.hasError('required')
                    "
                  >
                    Issued date is required.
                  </div>
                </div>
              </div>
            </div>
          </div>

          <div class="row">
            <div class="col-12">
              <div class="mb-3">
                <label for="upload" class="mb-2"
                  >Upload Document<span class="text-danger">*</span></label
                >
                <div class="upload-medical-records">
                  <input
                    #fileInput2
                    (change)="onFileChange($event)"
                    class="form-control"
                    type="file"
                    name="user_file"
                    id="user_files_mr"
                    accept=".pdf,.doc,.docx,.png,.jpg,.jpeg"
                  />
                  <div class="upload-content dropzone">
                    <div>
                      <div class="upload-icon mb-2">
                        <img
                          src="assets/img/upload-icon.png"
                          alt="upload-icon"
                        />
                      </div>
                      <h5>Drag &amp; Drop</h5>
                      <h6>
                        or
                        <span
                          class="text-danger"
                          style="color: #569ed5 !important"
                          >Browse</span
                        >
                      </h6>
                    </div>
                  </div>
                  <div
                    class="text-danger mt-1"
                    *ngIf="
                      medicalForm.get('userFile')?.touched &&
                      medicalForm.get('userFile')?.invalid
                    "
                  >
                    Document upload is required.
                  </div>
                  <div
                    *ngIf="uploadedFileName && uploadedFileName != ''"
                    class="mt-2 file-info"
                  >
                    <small
                      >Selected Document:
                      <strong>{{ uploadedFileName }}</strong></small
                    >
                  </div>
                </div>
              </div>
            </div>
          </div>

          <div class="row">
            <div class="col-12">
              <div class="mb-3">
                <label class="mb-2"
                  >Symptoms<span class="text-danger">*</span></label
                >
                <input
                  maxLength="200"
                  (keydown)="cleanInput($event)"
                  (input)="onlyAlphabet($event)"
                  type="text"
                  class="form-control"
                  placeholder="Enter Symptoms"
                  formControlName="symptoms"
                />
                <div
                  class="text-danger mt-1"
                  *ngIf="
                    medicalForm.get('symptoms')?.touched &&
                    medicalForm.get('symptoms')?.invalid
                  "
                >
                  <!-- changes by naved just change the text -->
                  Symptoms are required.
                </div>
              </div>
            </div>
          </div>

          <!-- Privacy Setting -->
          <div class="privacy-wrapper">
            <!-- Only Me -->
            <label
              class="privacy-card"
              [class.active]="
                medicalForm.get('privacy_setting')?.value === 'Only Me'
              "
            >
              <div class="privacy-left">
                <div>
                  <input
                    type="radio"
                    formControlName="privacy_setting"
                    value="Only Me"
                  />
                </div>

                <div class="privacy-details">
                  <h6>🔒 Only Me</h6>
                  <p>Visible only to me</p>
                </div>
              </div>
            </label>

            <!-- Anyone -->
            <label
              class="privacy-card"
              [class.active]="
                medicalForm.get('privacy_setting')?.value === 'Anyone'
              "
            >
              <div class="privacy-left">
                <div>
                  <input
                    type="radio"
                    formControlName="privacy_setting"
                    value="Anyone"
                  />
                </div>

                <div class="privacy-details">
                  <h6>🌐 Anyone</h6>
                  <p>Doctors and caregivers can view</p>
                </div>
              </div>
            </label>

            <!-- Only Caregiver -->
            <label
              class="privacy-card"
              [class.active]="
                medicalForm.get('privacy_setting')?.value === 'Only Caregiver'
              "
            >
              <div class="privacy-left">
                <div>
                  <input
                    type="radio"
                    formControlName="privacy_setting"
                    value="Only Caregiver"
                  />
                </div>

                <div class="privacy-details">
                  <h6>👤 Only Caregiver</h6>
                  <p>Visible only to assigned caregiver(s)</p>
                </div>
              </div>
            </label>
          </div>

          <!-- YES/NO Toggle with standalone ngModel -->
          <div class="row">
            <div class="col-12">
              <div class="mb-3">
                <label class="mb-2">Do you want to add any description?</label>
                <div>
                  <div class="form-check form-check-inline">
                    <input
                      class="form-check-input"
                      type="radio"
                      name="addDesc"
                      [value]="true"
                      [(ngModel)]="showDescription"
                      [ngModelOptions]="{ standalone: true }"
                    />
                    <label class="form-check-label">Yes</label>
                  </div>
                  <div class="form-check form-check-inline">
                    <input
                      class="form-check-input"
                      type="radio"
                      name="addDesc"
                      [value]="false"
                      [(ngModel)]="showDescription"
                      [ngModelOptions]="{ standalone: true }"
                    />
                    <label class="form-check-label">No</label>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <div class="row" *ngIf="showDescription">
            <div class="col-12">
              <div class="mb-3">
                <label class="mb-2">Description</label>
                <textarea
                  class="form-control"
                  maxLength="200"
                  style="max-height: 200px"
                  placeholder="Enter Description"
                  formControlName="description"
                  rows="4"
                  [(ngModel)]="text"
                  (input)="onInputChange($event)"
                >
                <!-- changes by naved --->
                </textarea>
                <p class="mb-0">
                  {{ text?.length == 0 ? 0 : charCount }} / 200 words
                </p>
                <!-- changes by naved --->
              </div>
            </div>
          </div>

          <div
            class="text-center mt-4"
            style="justify-content: center !important"
          >
            <button type="submit" class="btn medical_btn button_class">
              Submit
            </button>
          </div>
        </div>
      </form>
    </div>
  </div>
</div>
<!-- /Medical Records Modal -->

<!-- Modal -->
<div
  class="modal fade"
  id="deleteConfirmModal"
  tabindex="-1"
  role="dialog"
  aria-labelledby="deleteConfirmModal"
  aria-hidden="true"
>
  <div class="modal-dialog modal-dialog-centered">
    <div class="modal-content">
      <div class="modal-header">
        <button
          type="button"
          class="btn-close"
          data-bs-dismiss="modal"
          aria-label="Close"
        ></button>
      </div>
      <div class="modal-body">
        <p id="acc_msg"></p>
      </div>
      <div class="modal-footer">
        <a href="javascript:void(0)" class="btn btn-success si_accept_confirm"
          >Yes</a
        >
        <button
          type="button"
          class="btn btn-danger si_accept_cancel"
          data-bs-dismiss="modal"
        >
          Cancel
        </button>
      </div>
    </div>
  </div>
</div>

<div
  class="modal fade"
  id="deleteNotConfirmModal"
  tabindex="-1"
  role="dialog"
  aria-labelledby="deleteNotConfirmModal"
  style="display: none"
  aria-hidden="true"
>
  <div class="modal-dialog modal-dialog-centered">
    <div class="modal-content">
      <div class="modal-header">
        <h5 class="modal-title" id="acc_title">Inactive Service?</h5>
        <button
          type="button"
          class="btn-close"
          data-bs-dismiss="modal"
          aria-label="Close"
        ></button>
      </div>
      <div class="modal-body">
        <p id="acc_msg1">Service is Booked and Inprogress..</p>
      </div>
      <div class="modal-footer">
        <button
          type="button"
          class="btn btn-danger si_accept_cancel"
          data-bs-dismiss="modal"
        >
          OK
        </button>
      </div>
    </div>
  </div>
</div>
<!-- Modal -->

<!-- Telemedicine Consultation Modal -->
<div
  id="add_tele"
  class="modal fade custom-modal"
  tabindex="-1"
  role="dialog"
  aria-hidden="true"
>
  <div class="modal-dialog modal-dialog-centered">
    <div class="modal-content">
      <form
        [formGroup]="teleMedicineConsultForm"
        (ngSubmit)="onBookingTelemedicineConsultant()"
        class="book-consultation-form p-4"
      >
        <div class="d-flex gap-2 mb-2">
          <div class="w-75">
            <h5 class="modal-title">
              {{
                isUpdated
                  ? "Update your consultation"
                  : isReschedule
                    ? "Re-schedule your consultation"
                    : "Book Consultation"
              }}
            </h5>
          </div>
          <div class="w-25">
            <button
              type="button"
              class="btn-close float-end"
              data-bs-dismiss="modal"
              aria-label="Close"
              (click)="closePopup('consultation')"
            ></button>
          </div>
        </div>

        <div class="form-group mb-3">
          <label
            >Select Consultation Type <span class="text-danger">*</span></label
          >
          <select
            class="form-select form-control"
            formControlName="consultation_type"
          >
            <option [ngValue]="null" disabled>Select</option>
            <option>Consult with General Physician</option>
          </select>
          <div
            *ngIf="
              teleMedicineConsultForm.get('consultation_type')?.touched &&
              teleMedicineConsultForm.get('consultation_type')?.invalid
            "
            class="text-danger"
          >
            Consultation Type is required.
          </div>
        </div>

        <div class="form-group mb-3">
          <label>Select Patient <span class="text-danger">*</span></label>
          <select
            id="patient-select"
            class="form-select form-control"
            formControlName="patient"
            (change)="onPatientChange('telemedi')"
            [compareWith]="comparePatients"
          >
            <option [ngValue]="null" disabled>Select Patient</option>
            <option *ngFor="let patient of patientList" [ngValue]="patient">
              {{
                patient.first_name +
                  " " +
                  patient.last_name +
                  (patient.is_logged_in_user ? " (Me)" : "")
              }}
            </option>
          </select>
          <div
            *ngIf="
              teleMedicineConsultForm.get('patient')?.touched &&
              teleMedicineConsultForm.get('patient')?.invalid
            "
            class="text-danger"
          >
            Patient is required.
          </div>
        </div>

        <div class="form-group mb-3">
          <label>Age <span class="text-danger">*</span></label>

          <input
            type="text"
            inputmode="numeric"
            pattern="[0-9]*"
            maxlength="3"
            class="form-control"
            formControlName="age"
            placeholder="eg. 24"
            (keypress)="blockInvalidKeys($event)"
            (paste)="blockInvalidPaste($event)"
            (input)="validateAge('consultation')"
          />

          <div
            *ngIf="
              ageControl?.enabled && ageControl?.touched && ageControl?.invalid
            "
          >
            <div *ngIf="ageControl?.hasError('required')" class="text-danger">
              Age is required.
            </div>
            <div *ngIf="ageControl?.hasError('min')" class="text-danger">
              Age must be 18 or above
            </div>
          </div>
        </div>

        <div class="form-group mb-3">
          <label>Gender <span class="text-danger">*</span></label>
          <select class="form-select form-control" formControlName="gender">
            <option value="" disabled>Select</option>
            <option value="male">Male</option>
            <option value="female">Female</option>
            <option value="other">Other</option>
          </select>
          <div
            *ngIf="
              teleMedicineConsultForm.get('gender')?.touched &&
              teleMedicineConsultForm.get('gender')?.invalid
            "
            class="text-danger"
          >
            Gender is required.
          </div>
        </div>

        <div *ngIf="alaCartPriceOption === false || completeTelemedSub">
          <div class="form-group mb-3">
            <label>Currency <span class="text-danger">*</span></label>
            <select
              class="form-select form-control"
              (change)="getCurrencyPrice()"
              formControlName="currency"
            >
              <option [ngValue]="null" disabled selected>Select</option>
              <option value="USD">USD</option>
              <option value="ZWG">ZWG</option>
            </select>
            <div
              *ngIf="
                teleMedicineConsultForm.get('currency')?.hasError('required') &&
                teleMedicineConsultForm.get('currency')?.touched
              "
              class="text-danger"
            >
              Currency is required.
            </div>
          </div>
          <div class="form-group mb-3" *ngIf="currencyPrice > 0">
            <label>Price <span class="text-danger">*</span></label>
            <input
              type="number"
              class="form-control"
              formControlName="a_la_carte_price"
              placeholder="eg. 24"
            />
            <div
              *ngIf="
                teleMedicineConsultForm.get('a_la_carte_price')?.touched &&
                teleMedicineConsultForm.get('a_la_carte_price')?.invalid
              "
              class="text-danger"
            >
              Price is required.
            </div>
          </div>
        </div>
        <div class="form-group mb-3">
          <label>Phone Number <span class="text-danger">*</span></label>
          <div *ngIf="!telemediPatientHasPhone" class="form-control text-muted">
            NA
          </div>
          <ngx-intl-tel-input
            *ngIf="telemediPatientHasPhone"
            class="custom_imput custom_imput_disabled"
            [inputId]="'phone-input'"
            [cssClass]="'custom'"
            [preferredCountries]="preferredCountries"
            [enableAutoCountrySelect]="false"
            [enablePlaceholder]="false"
            [searchCountryFlag]="true"
            [searchCountryField]="[
              SearchCountryField.Iso2,
              SearchCountryField.Name,
            ]"
            [customPlaceholder]="'Enter Phone Number'"
            [selectFirstCountry]="true"
            [selectedCountryISO]="CountryISO.Zimbabwe"
            [separateDialCode]="true"
            [maxLength]="15"
            (input)="onPhoneInput($event)"
            [phoneValidation]="true"
            name="phone"
            formControlName="phone"
          >
          </ngx-intl-tel-input>
          <div
            *ngIf="
              telemediPatientHasPhone &&
              teleMedicineConsultForm.get('phone')?.touched
            "
            class="text-danger mt-1"
          >
            <div
              *ngIf="teleMedicineConsultForm.get('phone')?.errors?.required"
              class="text-danger"
            >
              Phone Number is required.
            </div>
            <div
              class="text-danger"
              *ngIf="
                !teleMedicineConsultForm.get('phone')?.errors?.required &&
                teleMedicineConsultForm.get('phone')?.errors
                  ?.invalidZimbabweMobile
              "
            >
              Invalid Zimbabwe phone number
            </div>
          </div>
        </div>
        <div class="form-group mb-3">
          <label
            >Reason for Consultation <span class="text-danger">*</span></label
          >
          <input
            type="text"
            class="form-control"
            formControlName="reason_for_consultation"
            placeholder="eg. Suffering Fever"
          />
          <div
            *ngIf="
              teleMedicineConsultForm.get('reason_for_consultation')?.touched &&
              teleMedicineConsultForm.get('reason_for_consultation')?.invalid
            "
            class="text-danger"
          >
            Reason for consultation is required.
          </div>
        </div>
        <div class="form-group mb-3">
          <label
            >Plan Your Consultation <span class="text-danger">*</span></label
          >
          <select
            class="form-select form-control"
            formControlName="plan_consultation"
          >
            <option [ngValue]="null" disabled>Select</option>
            <option value="Scheduled">Schedule</option>
            <option value="Consult Now">Consult Now</option>
          </select>
          <div
            *ngIf="
              teleMedicineConsultForm.get('plan_consultation')?.touched &&
              teleMedicineConsultForm.get('plan_consultation')?.invalid
            "
            class="text-danger"
          >
            Consultation is required.
          </div>
        </div>

        <div
          class="form-group mb-3"
          *ngIf="
            teleMedicineConsultForm.get('plan_consultation')?.value !==
            'Consult Now'
          "
        >
          <label
            >Appointment Date & Slots <span class="text-danger">*</span></label
          >
          <div class="d-flex gap-2">
            <div class="w-50">
              <div
                class="position-relative"
                [ngClass]="{ custom_disabled: isFieldDisabled }"
              >
                <input
                  #dp1="bsDatepicker"
                  type="text"
                  class="form-control"
                  bsDatepicker
                  placement="top"
                  placeholder="Select Date"
                  formControlName="appointment_date"
                  (bsValueChange)="getSlotsData($event)"
                  [bsConfig]="bsDatepickerConfig"
                  [outsideClick]="true"
                  inputmode="none"
                  readonly
                  onkeydown="return false;"
                />
                <i
                  class="fa-regular fa-calendar position-absolute"
                  (click)="dp1.toggle()"
                ></i>
              </div>
              <div
                *ngIf="
                  teleMedicineConsultForm.get('appointment_date')?.touched &&
                  teleMedicineConsultForm.get('appointment_date')?.invalid
                "
                class="text-danger"
              >
                Date is required.
              </div>
            </div>

            <div class="w-50">
              <select
                class="form-select form-control"
                [disabled]="slotsList.length > 0"
                formControlName="slot_id"
                [ngClass]="{ custom_disabled: isFieldDisabled }"
              >
                <option [ngValue]="null" disabled>Select Slot</option>
                <option *ngFor="let list of slotsList" [ngValue]="list.slot_id">
                  {{ list.slots }}
                </option>
              </select>
              <div
                *ngIf="
                  teleMedicineConsultForm.get('slot_id')?.touched &&
                  teleMedicineConsultForm.get('slot_id')?.invalid
                "
                class="text-danger"
              >
                Slot is required.
              </div>
            </div>
          </div>
        </div>

        <!-- select medical records -->
        <div class="form-group mb-3">
          <label>Add Medical Records</label>

          <ng-select
            [items]="unlockMedicalList"
            bindLabel="displayText"
            [multiple]="true"
            [closeOnSelect]="false"
            [compareWith]="compareObjects"
            [searchable]="true"
            placeholder="Select Medical Records"
            formControlName="medical_report_id"
          >
          </ng-select>
        </div>

        <div
          class="form-group note-card mb-3"
          *ngIf="alaCartPriceOption === false && !isReschedule"
        >
          <div class="note-header">Note -</div>
          <div class="note-body">
            {{ constant.CONSULTANT_NOTE }}
          </div>
        </div>
        <div
          class="form-group note-card mb-3"
          *ngIf="alaCartPriceOption && !isReschedule"
        >
          <div class="note-header">Note -</div>
          <div class="note-body">
            {{
              completeTelemedSub
                ? constant.CONSULTANT_NOTE
                : "You have used " +
                  subTelemedCount +
                  " out of 12 consultations this year."
            }}
          </div>
        </div>
        <div class="form-group custom-center">
          <button type="submit" class="add-new-btn button_class">
            Book Consultation
          </button>
          <button
            type="button"
            id="telemodel"
            class="d-none"
            data-bs-dismiss="modal"
          ></button>
        </div>
      </form>
    </div>
  </div>
</div>
<!-- Telemedicine Consultation Modal -->

<!-- Book ambulance -->
<div
  id="book_amb"
  class="modal fade custom-modal"
  tabindex="-1"
  data-bs-focus="false"
  role="dialog"
  aria-hidden="true"
>
  <div class="modal-dialog modal-dialog-centered">
    <div class="modal-content">
      <form
        [formGroup]="ambulanceForm"
        (ngSubmit)="proceed()"
        class="book-consultation-form p-4"
      >
        <div
          class="modal-header"
          style="padding: 0px; border: none; padding-bottom: 10px"
        >
          <h4 class="mb-3">Book Ambulance</h4>
          <button
            type="button"
            class="btn-close"
            data-bs-dismiss="modal"
            aria-label="Close"
          ></button>
        </div>
        <div class="form-group mb-3">
          <label>Select Patient <span class="text-danger">*</span></label>
          <select
            id="patient-select"
            class="form-select form-control"
            formControlName="patient"
            (change)="onPatientChange('ambulance')"
          >
            <option [ngValue]="null" disabled>Select Patient</option>
            <option *ngFor="let patient of patientList" [ngValue]="patient">
              {{
                patient.first_name +
                  " " +
                  patient.last_name +
                  (patient.is_logged_in_user ? " (Me)" : "")
              }}
            </option>
          </select>

          <div
            *ngIf="
              ambulanceForm.get('patient')?.touched &&
              ambulanceForm.get('patient')?.invalid
            "
            class="text-danger"
          >
            Patient is required.
          </div>
        </div>

        <div class="form-group mb-3">
          <label>Age <span class="text-danger">*</span></label>
          <input
            type="text"
            inputmode="numeric"
            pattern="[0-9]*"
            maxlength="3"
            class="form-control"
            formControlName="age"
            placeholder="Enter Age"
            (keypress)="blockInvalidKeys($event)"
            (paste)="blockInvalidPaste($event)"
            (input)="validateAge('ambulance')"
          />
          <div *ngIf="ageCtrl?.enabled && ageCtrl?.touched && ageCtrl?.invalid">
            <div *ngIf="ageCtrl?.hasError('required')" class="text-danger">
              Age is required.
            </div>
            <div *ngIf="ageCtrl?.hasError('min')" class="text-danger">
              Age must be 18 or above
            </div>
          </div>
        </div>

        <div class="form-group mb-3">
          <label>Gender <span class="text-danger">*</span></label>
          <select class="form-select form-control" formControlName="gender">
            <option value="" disabled selected>Select Gender</option>
            <option value="male">Male</option>
            <option value="female">Female</option>
            <option value="other">Other</option>
          </select>
          <div
            *ngIf="
              ambulanceForm.get('gender')?.touched &&
              ambulanceForm.get('gender')?.invalid
            "
            class="text-danger"
          >
            Gender is required.
          </div>
        </div>

        <div class="form-group mb-3">
          <label>Phone Number <span class="text-danger">*</span></label>
          <div
            *ngIf="!ambulancePatientHasPhone"
            class="form-control text-muted"
          >
            NA
          </div>
          <ngx-intl-tel-input
            *ngIf="ambulancePatientHasPhone"
            class="custom_imput custom_imput_disabled"
            [inputId]="'phone-input'"
            [cssClass]="'custom'"
            [preferredCountries]="preferredCountries"
            [enableAutoCountrySelect]="false"
            [enablePlaceholder]="false"
            [searchCountryFlag]="true"
            [searchCountryField]="[
              SearchCountryField.Iso2,
              SearchCountryField.Name,
            ]"
            [customPlaceholder]="'Enter Phone Number'"
            [selectFirstCountry]="true"
            [selectedCountryISO]="CountryISO.Zimbabwe"
            [separateDialCode]="true"
            [maxLength]="15"
            (input)="onPhoneInput($event)"
            [phoneValidation]="true"
            name="phone"
            formControlName="phone"
          >
          </ngx-intl-tel-input>
          <div
            *ngIf="
              ambulancePatientHasPhone && ambulanceForm.get('phone')?.touched
            "
            class="text-danger mt-1"
          >
            <div
              style="color: red !important"
              *ngIf="ambulanceForm.get('phone')?.errors?.required"
            >
              Phone Number is required.
            </div>
            <div
              style="color: red !important"
              *ngIf="
                !ambulanceForm.get('phone')?.errors?.required &&
                ambulanceForm.get('phone')?.errors?.invalidZimbabweMobile
              "
            >
              Invalid Zimbabwe phone number
            </div>
          </div>
        </div>

        <div class="form-group mb-3">
          <label>Medical Condition <span class="text-danger">*</span></label>
          <input
            (keydown)="cleanInput($event)"
            type="text"
            placeholder="Enter Medical Condition"
            class="form-control"
            formControlName="medicalReason"
          />
          <div
            *ngIf="
              ambulanceForm.get('medicalReason')?.touched &&
              ambulanceForm.get('medicalReason')?.invalid
            "
            class="text-danger"
          >
            Medical Condition is required.
          </div>
        </div>

        <div class="form-group mb-3">
          <!-- Address -->
          <label class="pick-lable"
            >Flat No./House No./Building Name
            <!-- <span class="text-danger">*</span> -->
          </label>
          <input
            type="text"
            placeholder="Enter Pick-up Address"
            class="form-control"
            formControlName="buildingPickLocation"
            maxlength="100"
          />
          <div class="text-muted small mt-1">
            {{
              ambulanceForm.get("buildingPickLocation")?.value?.length || 0
            }}/100
          </div>

          <div
            *ngIf="
              ambulanceForm.get('buildingPickLocation')?.touched &&
              ambulanceForm.get('buildingPickLocation')?.invalid
            "
            class="text-danger"
          >
            <div
              class="text-danger"
              *ngIf="
                ambulanceForm.get('buildingPickLocation')?.errors?.['maxlength']
              "
            >
              Address cannot exceed 100 characters.
            </div>
          </div>

          <label>Pickup Location <span class="text-danger">*</span></label>

          <input
            type="text"
            class="form-control"
            placeholder="Select pickup location"
            formControlName="pickLocation"
            readonly
            (click)="openMap('pickup')"
          />

          <div
            *ngIf="
              ambulanceForm.get('pickLocation')?.touched &&
              ambulanceForm.get('pickLocation')?.hasError('required')
            "
            class="text-danger"
          >
            Pickup Location is required.
          </div>

          <small class="text-success mt-1">
            <span class="use-location" (click)="openMap('pickup')">
              📍 Use current location
            </span>
          </small>
        </div>

        <div class="form-group mb-3">
          <!-- Address -->
          <label class="pick-lable"
            >Flat No./House No./Building Name
            <!-- <span class="text-danger">*</span> -->
          </label>
          <input
            type="text"
            placeholder="Enter Drop-off Address"
            class="form-control"
            formControlName="buildingDropLocation"
            maxlength="100"
          />
          <div class="text-muted small mt-1">
            {{
              ambulanceForm.get("buildingDropLocation")?.value?.length || 0
            }}/100
          </div>
          <div
            *ngIf="
              ambulanceForm.get('buildingDropLocation')?.touched &&
              ambulanceForm.get('buildingDropLocation')?.invalid
            "
            class="text-danger"
          >
            <div
              class="text-danger"
              *ngIf="
                ambulanceForm.get('buildingDropLocation')?.errors?.['maxlength']
              "
            >
              Address cannot exceed 100 characters.
            </div>
          </div>
          <label>Dropoff Location <span class="text-danger">*</span></label>
          <input
            type="text"
            class="form-control"
            placeholder="Select drop-off location"
            formControlName="dropLocation"
            readonly
            (click)="openMap('drop')"
          />
        </div>

        <div
          *ngIf="
            ambulanceForm.get('dropLocation')?.touched &&
            ambulanceForm.get('dropLocation')?.hasError('required')
          "
          class="text-danger"
        >
          Dropoff Location is required.
        </div>

        <!-- <div
          class="text-danger same-address"
          *ngIf="
            ambulanceForm.get('pickLocation')?.errors?.['sameAddress'] ||
            ambulanceForm.get('dropLocation')?.errors?.['sameAddress']
          "
        >
          Pick-up and Drop-off address cannot be the same.
        </div> -->

        <div
          class="text-danger same-address mt-2"
          *ngIf="
            ambulanceForm.errors?.['sameAddress'] &&
            (ambulanceForm.touched || ambulanceForm.dirty)
          "
        >
          Pick-up and Drop-off address cannot be the same.
        </div>

        <div class="form-group custom-center">
          <button type="submit" class="add-new-btn button_class">
            Book Ambulance
          </button>
          <button
            type="button"
            id="book"
            class="d-none"
            data-bs-dismiss="modal"
          ></button>
        </div>
      </form>
    </div>
  </div>
</div>
<!-- Book ambulance -->

<!-- Edit book ambulance -->
<div
  id="edit_amb"
  class="modal fade custom-modal"
  tabindex="-1"
  role="dialog"
  aria-hidden="true"
>
  <div class="modal-dialog modal-dialog-centered">
    <div class="modal-content">
      <form
        [formGroup]="EditambulanceForm"
        (ngSubmit)="onEditBooking()"
        class="book-consultation-form p-4"
      >
        <div
          class="modal-header"
          style="padding: 0px; border: none; padding-bottom: 10px"
        >
          <h4 class="mb-3">Edit Ambulance Booking</h4>
          <button
            type="button"
            class="btn-close"
            data-bs-dismiss="modal"
            aria-label="Close"
          ></button>
        </div>
        <div class="form-group mb-3">
          <label>Select Patient <span class="text-danger">*</span></label>
          <select
            id="patient-select"
            class="form-select form-control"
            formControlName="patient"
            (change)="onPatientChange('ambulance')"
          >
            <option [ngValue]="null" disabled>Select Patient</option>
            <option *ngFor="let patient of patientList" [ngValue]="patient">
              {{
                patient.first_name +
                  " " +
                  patient.last_name +
                  (patient.is_logged_in_user ? " (Me)" : "")
              }}
            </option>
          </select>

          <div
            *ngIf="
              ambulanceForm.get('patient')?.touched &&
              ambulanceForm.get('patient')?.invalid
            "
            class="text-danger"
          >
            Patient is required
          </div>
        </div>

        <div class="form-group mb-3">
          <label>Age <span class="text-danger">*</span></label>
          <input type="number" class="form-control" formControlName="age" />
        </div>

        <div class="form-group mb-3">
          <label>Gender <span class="text-danger">*</span></label>
          <select class="form-select form-control" formControlName="gender">
            <option value="" disabled>Select</option>
            <option value="male">Male</option>
            <option value="female">Female</option>
            <option value="other">Other</option>
          </select>
        </div>

        <div class="form-group mb-3">
          <label>Phone Number <span class="text-danger">*</span></label>
          <ngx-intl-tel-input
            class="custom_imput"
            [inputId]="'phone-input'"
            [cssClass]="'custom model-class'"
            [preferredCountries]="preferredCountries"
            [enableAutoCountrySelect]="false"
            [enablePlaceholder]="false"
            [searchCountryFlag]="true"
            [searchCountryField]="[
              SearchCountryField.Iso2,
              SearchCountryField.Name,
            ]"
            [customPlaceholder]="'Enter Phone Number'"
            [selectFirstCountry]="true"
            [selectedCountryISO]="CountryISO.Zimbabwe"
            [separateDialCode]="true"
            [maxLength]="15"
            (input)="onPhoneInput($event)"
            [phoneValidation]="true"
            name="phone"
            formControlName="phone"
          >
          </ngx-intl-tel-input>
          <div
            *ngIf="EditambulanceForm.get('phone')?.touched"
            class="text-danger mt-1"
          >
            <div *ngIf="EditambulanceForm.get('phone')?.errors?.required">
              Phone is required
            </div>
            <div
              *ngIf="
                !EditambulanceForm.get('phone')?.errors?.required &&
                EditambulanceForm.get('phone')?.errors?.invalidZimbabweMobile
              "
            >
              Invalid Zimbabwe phone number
            </div>
          </div>
        </div>

        <div class="form-group mb-3">
          <label>Medical Condition</label>
          <input
            (keydown)="cleanInput($event)"
            type="text"
            placeholder="Enter Medical Condtion"
            class="form-control"
            formControlName="medicalReason"
          />
        </div>

        <div class="form-group mb-3">
          <label>Pic-kup Location <span class="text-danger">*</span></label>
          <input
            type="text"
            placeholder="Enter Pick-up Condtion"
            class="form-control"
            formControlName="pickLocation"
          />
          <div
            *ngIf="
              ambulanceForm.get('pickLocation')?.touched &&
              ambulanceForm.get('pickLocation')?.invalid
            "
            class="text-danger"
          >
            Pick-up Location is required
          </div>
        </div>

        <div class="form-group mb-3">
          <label>Drop Up Location <span class="text-danger">*</span></label>
          <input
            type="text"
            placeholder="Enter DropUp Condtion"
            class="form-control"
            formControlName="dropLocation"
          />
          <div
            *ngIf="
              ambulanceForm.get('dropLocation')?.touched &&
              ambulanceForm.get('dropLocation')?.invalid
            "
            class="text-danger"
          >
            Drop Up Location is required
          </div>
        </div>

        <div class="form-group custom-center">
          <button type="submit" class="add-new-btn">Edit Booking</button>
          <button
            type="button"
            id="updated"
            class="d-none"
            data-bs-dismiss="modal"
          ></button>
        </div>
      </form>
    </div>
  </div>
</div>
<!-- Edit book ambulance -->

<div class="modal fade" id="terms_condition" aria-hidden="true" role="dialog">
  <div class="modal-dialog modal-dialog-centered terms-modal" role="document">
    <div class="modal-content">
      <div class="modal-header">
        <button
          type="button"
          class="btn-close"
          data-bs-dismiss="modal"
          aria-label="Close"
        ></button>
      </div>
      <div class="modal-body">
        <app-terms-condition></app-terms-condition>
      </div>
    </div>
  </div>
</div>

<div class="modal fade" id="privacy_policy" aria-hidden="true" role="dialog">
  <div class="modal-dialog modal-dialog-centered terms-modal" role="document">
    <div class="modal-content">
      <div class="modal-header">
        <button
          type="button"
          class="btn-close"
          data-bs-dismiss="modal"
          aria-label="Close"
        ></button>
      </div>
      <div class="modal-body">
        <app-privacy-policy></app-privacy-policy>
      </div>
    </div>
  </div>
</div>

<!-- Prescription PDF -->
<div class="modal fade" id="prescription_pdf" aria-hidden="true" role="dialog">
  <div class="modal-dialog modal-dialog-centered terms-modal" role="document">
    <div class="modal-content pdf-modal-content">
      <div class="modal-header">
        <button
          type="button"
          class="btn-close"
          data-bs-dismiss="modal"
          aria-label="Close"
        ></button>
      </div>
      <div class="modal-body">
        @if (pdfUrl) {
          <iframe
            [src]="pdfUrl"
            width="100%"
            height="100%"
            style="border: none"
          >
          </iframe>
        }
      </div>
    </div>
  </div>
</div>

<!-- Cancel Appointment -->
<div class="cancel-modal modal fade" id="cancel_consultation" tabindex="-1">
  <div class="modal-dialog modal-dialog-centered">
    <div class="modal-content cancel-modal__content">
      <div class="cancel-modal__header">
        <button
          type="button"
          class="cancel-modal__close"
          data-bs-dismiss="modal"
        >
          ✕
        </button>
      </div>

      <div class="cancel-modal__body">
        <div class="cancel-modal__icon">!</div>
        <h2 class="cancel-modal__title">Cancel appointment?</h2>
        <p class="cancel-modal__subtitle">
          You won’t be able to attend this consultation after cancellation.
        </p>

        <div class="cancel-modal__schedule">
          <div class="cancel-modal__avatar">DR</div>
          <div>
            <div class="cancel-modal__label">
              {{ selectedAppointment?.tc_plan_type }} at
            </div>
            <div class="cancel-modal__time">
              {{
                selectedAppointment?.tc_plan_type == "Consult Now"
                  ? (selectedAppointment?.booking_date | date: "dd MMM yyyy")
                  : (selectedAppointment?.booking_date | date: "dd MMM yyyy")
              }}
              •
              {{
                selectedAppointment?.tc_plan_type == "Consult Now"
                  ? (selectedAppointment?.createdAt | date: "hh:mm a")
                  : selectedAppointment?.booking_time
              }}
            </div>
          </div>
        </div>

        <div class="cancel-modal__reason">
          <p class="cancel-modal__reason-title">
            Please specify your reason for cancellation
          </p>

          <label *ngFor="let reason of reasons" class="cancel-modal__radio">
            <input
              type="radio"
              name="reason"
              [value]="reason"
              [(ngModel)]="selectedReason"
            />
            <span>{{ reason }}</span>
          </label>
        </div>

        <div class="cancel-modal__actions">
          <button
            class="cancel-modal__btn cancel-modal__btn--secondary"
            (click)="closeCancelPopup()"
          >
            Keep appointment
          </button>

          <button
            class="add-new-btn button_class"
            [disabled]="!selectedReason"
            (click)="confirmCancel()"
          >
            Cancel appointment
          </button>
        </div>
      </div>
    </div>
  </div>
</div>

<!-- Set Reminder -->
<div class="cancel-modal modal fade" id="set_reminder" tabindex="-1">
  <div class="modal-dialog modal-dialog-centered">
    <div class="modal-content cancel-modal__content">
      <!-- HEADER -->
      <div class="set-reminder-header">
        <div>
          <h3>Consultation Reminder</h3>
          <p>Get notified before your consultation starts.</p>
        </div>
        <button
          type="button"
          class="cancel-modal__close"
          data-bs-dismiss="modal"
        >
          ✕
        </button>
      </div>

      <!-- BODY -->
      <div class="reminder-body">
        <h4>When should we remind you?</h4>
        <p class="sub">Choose how early you'd like to receive a reminder.</p>

        <div class="options">
          <label *ngFor="let item of minutes" class="cancel-modal__radio">
            <input
              type="radio"
              name="time"
              [value]="item.value"
              [(ngModel)]="selectedMinute"
            />
            <span>{{ item.label }}</span>
          </label>
        </div>

        <!-- NOTIFICATION -->
        <h4>How would you like to be notified?</h4>
        <p class="sub">Choose your preferred notification method.</p>

        <div class="notify-options">
          <div
            class="notify"
            [class.active]="selectedOptions.includes('APP')"
            (click)="toggleOption('APP')"
          >
            📱<span>App</span>
          </div>

          <div
            class="notify"
            [class.active]="selectedOptions.includes('SMS')"
            (click)="toggleOption('SMS')"
          >
            💬<span>SMS</span>
          </div>
        </div>

        <p class="hint">You can select multiple options</p>

        <!-- BUTTON -->
        <button class="add-new-btn button_class" (click)="setReminder()">
          Set Reminder →
        </button>
      </div>
    </div>
  </div>
</div>

<!-- Rating -->
<div class="cancel-modal modal fade" id="rating_modal" tabindex="-1">
  <div class="modal-dialog modal-dialog-centered">
    <div class="modal-content cancel-modal__content">
      <!-- HEADER -->
      <div class="rating-header">
        <div>
          <h5>Rate your consultation</h5>
          <p>
            How was your consultation with Dr.
            {{
              (selectedAppointment?.doctor_first_name || "") +
                " " +
                (selectedAppointment?.doctor_last_name || "")
            }}?
          </p>
        </div>
        <button
          type="button"
          class="cancel-modal__close"
          data-bs-dismiss="modal"
        >
          ✕
        </button>
      </div>

      <!-- BODY -->
      <div class="rating-body">
        <!-- DOCTOR CARD -->
        <div class="doctor-card">
          <div class="avatar">{{ getInitials() }}</div>
          <div>
            <div class="name">
              {{
                (selectedAppointment?.doctor_first_name || "") +
                  " " +
                  (selectedAppointment?.doctor_last_name || "")
              }}
            </div>
            <div class="speciality">
              {{ selectedAppointment?.doctor_speciality_name }}
            </div>
          </div>
        </div>

        <!-- STAR -->
        <div class="stars">
          <span
            *ngFor="let s of [1, 2, 3, 4, 5]"
            (click)="setRating(s)"
            [class.active]="s <= rating"
          >
            ★
          </span>
        </div>

        <div class="rating-text" *ngIf="rating">
          {{ getRatingText(rating) }}
        </div>

        <!-- FEEDBACK -->
        <label>Additional Feedback (Optional)</label>
        <textarea
          class="feedback-textarea"
          placeholder="Tell us more about your experience..."
          [(ngModel)]="review"
        ></textarea>

        <div *ngFor="let q of ratingQuesAns">
          <label>{{ q.question }}</label>

          <div class="options">
            <div
              class="option"
              *ngFor="let ans of q.answers"
              [class.active]="selectedAnswers[q.question_id] === ans.answer_id"
              (click)="selectAnswer(q.question_id, ans.answer_id)"
            >
              <span class="radio"></span>
              {{ ans.answer }}
            </div>
          </div>
        </div>

        <!-- BUTTON -->
        <button class="add-new-btn button_class" (click)="submitRating()">
          Submit Feedback →
        </button>
      </div>
    </div>
  </div>
</div>

<!-- View Summary -->
<div class="cancel-modal modal fade" id="view_summary_modal" tabindex="-1">
  <div class="modal-dialog modal-dialog-centered">
    <div class="modal-content cancel-modal__content">
      <!-- HEADER -->
      <div class="view-summary-header">
        <button
          type="button"
          class="summary-close-btn"
          data-bs-dismiss="modal"
          aria-label="Close"
        >
          ✕
        </button>
        <h2>Consultation Summary</h2>
        <p>Details from your completed online consultation</p>

        <div class="doctor-card">
          <div class="avatar">{{ getInitials() }}</div>
          <div>
            <div class="name">
              {{
                (selectedAppointment?.doctor_first_name || "") +
                  " " +
                  (selectedAppointment?.doctor_last_name || "")
              }}
            </div>
            <div class="meta">
              {{ selectedAppointment?.doctor_speciality_name }} ·
              {{ getPatientAge(selectedAppointment?.doctor_age) || "NA" }} years
              experience
            </div>
            <div class="time">
              📅
              {{
                selectedAppointment?.tc_plan_type == "Consult Now"
                  ? (selectedAppointment?.booking_date | date: "dd MMM yyyy")
                  : (selectedAppointment?.booking_date | date: "dd MMM yyyy")
              }}
              ,
              {{
                selectedAppointment?.tc_plan_type == "Consult Now"
                  ? (selectedAppointment?.createdAt | date: "hh:mm a")
                  : selectedAppointment?.booking_time
              }}
            </div>
          </div>
        </div>
      </div>

      <!-- BODY -->
      <div class="summary-body">
        <!-- DIAGNOSIS -->
        <div class="section">
          <h4>Diagnosis</h4>
          <p class="sub">Doctor's medical assessment</p>
          <p class="desc">
            {{
              selectedAppointment?.prescriptionDetail == null
                ? "NA"
                : selectedAppointment?.prescriptionDetail?.symptoms
            }}
          </p>

          <!-- ACTION CARDS -->
          <div class="action-cards-row">
            <div class="action-card" (click)="openChatFromSummary()">
              <div class="action-card__icon">💬</div>
              <div class="action-card__text">
                <span class="action-card__label">Open Chat</span>
                <span class="action-card__desc">View consultation chat</span>
              </div>
              <span class="action-card__arrow">›</span>
            </div>
            <div class="action-card">
              <div class="action-card__icon">📄</div>
              <div class="action-card__text">
                <span class="action-card__label">Get Payment Receipt</span>
              </div>
              <span class="action-card__arrow">›</span>
            </div>
          </div>
        </div>

        <!-- PRESCRIPTION -->
        <div class="section">
          <h4>Prescription</h4>
          <p class="sub">Medications prescribed</p>

          <ul class="list">
            <li>✔ Amoxicillin 500mg – Twice daily</li>
            <li>✔ Paracetamol – As needed</li>
          </ul>

          <button class="outline-btn full">📄 Get Prescription</button>
        </div>

        <!-- SESSION RECORDING -->
        <div class="section">
          <h4 class="section-title">SESSION RECORDING</h4>
          <p class="sub">Audio/video recording of your consultation</p>

          <label class="recording-label">Audio Recording</label>
          <div class="audio-box">
            <div class="audio-left">
              <span class="play">▶</span>
              <div class="wave"></div>
            </div>
            <span class="time">05:12</span>
          </div>
        </div>

        <!-- PAYMENT -->
        <div class="section">
          <h4 class="section-title">PAYMENT SUMMARY</h4>
          <p class="sub">Breakdown of charges</p>

          <div class="payment-card">
            <div class="payment-row">
              <span>Consultation Fee</span>
              <span>
                {{
                  selectedAppointment?.is_al_carte == 1
                    ? selectedAppointment?.currency +
                      " " +
                      selectedAppointment?.a_la_carte_price
                    : "NA"
                }}
              </span>
            </div>

            <div class="payment-row">
              <span>Additional Cost</span>
              <span>00.00</span>
            </div>

            <div class="payment-row total">
              <span>Total Paid</span>
              <span>
                {{
                  selectedAppointment?.is_al_carte == 1
                    ? selectedAppointment?.currency +
                      " " +
                      selectedAppointment?.a_la_carte_price
                    : "NA"
                }}
              </span>
            </div>

            <div class="payment-footer">
              <span>Payment Method: <b>EcoCash</b></span>
              <span>TXN4587392</span>
            </div>
          </div>
        </div>

        <!-- RATE -->
        <div class="rate-box">
          <div>
            <h4>Rate This Consultation</h4>
            <p>Share your experience to help other patients.</p>
          </div>

          <button class="rate-btn" (click)="openRatingFromSummary()">
            ⭐ <span>Rate Now</span>
          </button>
        </div>
      </div>
    </div>
  </div>
</div>

<!-- Show Map -->
<div class="map-overlay" *ngIf="showMap">
  <div class="map-box">
    <div class="map-header">
      <h5>Select Location</h5>
      <button
        type="button"
        class="btn-close"
        aria-label="Close map"
        (click)="closeMap()"
      ></button>
    </div>

    <div class="map-body">
      <div class="map-loader" *ngIf="isMapLoading">
        <div class="spinner-border text-primary"></div>
        <p>Loading map...</p>
      </div>

      <div class="place-search-box" *ngIf="mapMode === 'select'">
        <input
          type="text"
          class="form-control"
          placeholder="Search location"
          [ngModel]="placeSearchQuery"
          [ngModelOptions]="{ standalone: true }"
          (ngModelChange)="onPlaceSearchInput($event)"
          (focus)="showPlaceSuggestions = placePredictions.length > 0"
        />
        <div
          class="place-search-spinner"
          *ngIf="isSearchingPlaces || isResolvingPlace"
        >
          <div class="spinner-border spinner-border-sm text-primary"></div>
        </div>

        <ul class="place-suggestions" *ngIf="showPlaceSuggestions">
          <li
            *ngFor="let prediction of placePredictions"
            (click)="selectPlacePrediction(prediction)"
          >
            <strong>{{
              prediction.structuredFormat?.mainText?.text ||
                prediction.text?.text
            }}</strong>
            <span *ngIf="prediction.structuredFormat?.secondaryText?.text">
              {{ prediction.structuredFormat?.secondaryText?.text }}
            </span>
          </li>
        </ul>
      </div>

      <div id="map" class="map-container"></div>
    </div>

    <div class="map-footer">
      <button
        *ngIf="mapMode === 'select'"
        type="button"
        class="btn button_class w-100 no-hover"
        [disabled]="isFetchingAddress"
        (click)="confirmLocation()"
      >
        {{ isFetchingAddress ? "Fetching address..." : "Confirm Location" }}
      </button>

      <button
        *ngIf="mapMode === 'route'"
        type="button"
        class="btn button_class w-100 no-hover"
        (click)="onBookingAmbulance()"
      >
        Confirm &amp; Book
      </button>
    </div>
  </div>
</div>

<ngx-spinner
  bdColor="rgba(51, 51, 51, 0.8)"
  size="medium"
  color="skyblue"
  type="ball-clip-rotate"
  [fullScreen]="true"
>
  <p class="spinner-text">Please wait...</p>
</ngx-spinner>
